import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import './App.css';
import { SideNav } from './SideNav/SideNav';
import {Home} from './Home/home';
import {About} from './About/about';
import {Contact} from './Contact/contact';
import {useState, useEffect} from 'react';
import DehazeIcon from '@material-ui/icons/Dehaze';
import CloseIcon from '@material-ui/icons/Close';
import {Resume} from './Resume/resume';
import ReactNotification from 'react-notifications-component'

function App(props) {
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [isSideScreen, setSideScreen] = useState(window.innerWidth < 600?false: true);
  useEffect(() => {
    setScreenSize(window.innerWidth);
  })
  return (
  <Router>
       <ReactNotification />
    <div className="App">
      <div className={`${!isSideScreen ?'app-side-small':'app-side'}`}>
        <SideNav screenSize = {screenSize}/>
      </div>
      <div className ={`${screenSize < 600?'workingSpace-small':'workingSpace'}`}>
        {screenSize < 600 ?
            <button className = {`${isSideScreen?'header-toggler-open':'header-toggler'}`} onClick = {()=> setSideScreen(!isSideScreen)}>
                {isSideScreen? <CloseIcon/>: <DehazeIcon/>}
            </button>
            :
            null
        }
          <Switch>
          <Route  exact path="/about" component={About} />
          <Route  exact path="/contact" component={Contact} />
          <Route  exact path="/resume" component={Resume} />
          <Route  path="/" component={Home} />
        </Switch>
      </div>
    </div>
  </Router>
  );
}

export default App;
